import { UserRoles } from '../consts'

export const checkKeycloakAdminRoles = (roles?: string[]) => {
    if (!roles || roles.length === 0) {
        return false
    }

    return roles.some((role) => role.toLowerCase() === UserRoles.ADMIN.toLowerCase())
}
